import find from 'lodash/find'
// Local
import { TenantProperty } from '../authenticated/types'

export type ValueOf<T> = T[keyof T]

/** *****************************************************************************
 * Provides utilities for managing tenant properties
 */

export const findProperty = (
  key: ValueOf<TenantProperty>,
  properties: TenantProperty[] = []
): TenantProperty | undefined => find(properties, p => p.propertyKey === key)

export function hasProperty(
  properties: TenantProperty[],
  key: ValueOf<TenantProperty>
): boolean {
  const prop = findProperty(key, properties)
  return !!prop
}

export function propertyValue(
  properties: TenantProperty[],
  key: ValueOf<TenantProperty>
): string | null {
  const prop = findProperty(key, properties)
  return prop ? prop.propertyValue : null
}

export function booleanPropertyEnabled(
  properties: TenantProperty[],
  key: ValueOf<TenantProperty>
): boolean {
  const pvalue = propertyValue(properties, key)      
  return !!pvalue && pvalue.toLowerCase().startsWith('t')
}

export default {
  findProperty,
  hasProperty,
  propertyValue,
  booleanPropertyEnabled
}
